'use client';

import { useEffect } from 'react';
import { notifyError, formatError, isChunkLoadError, isExtensionError } from '../lib/error-logger';

export default function ErrorHandler() {
  useEffect(() => {
    const handleError = (event) => {
      const message = event.message || formatError(event.error);

      if (isChunkLoadError(message)) {
        window.location.reload();
        return;
      }

      // Drop errors injected by browser extensions / non-app sources. The
      // extension origin lives in the source filename or the error stack, not
      // in the message — so check both before reporting.
      if (isExtensionError(`${event.filename || ''}\n${event.error?.stack || ''}`)) {
        return;
      }

      notifyError(`Unhandled error: ${message}`, event.error?.stack);
    };

    const handleRejection = (event) => {
      const message = formatError(event.reason);

      if (isChunkLoadError(message)) {
        window.location.reload();
        return;
      }

      if (isExtensionError(`${message}\n${event.reason?.stack || ''}`)) {
        return;
      }

      notifyError(`Unhandled rejection: ${message}`, event.reason?.stack);
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleRejection);
    };
  }, []);

  return null;
}
